import { createFileRoute } from '@tanstack/react-router'
import { Playground } from './-components/api/playground/playground'
import { PanelBlockPending } from './-components/app-layout-skeleton'

// Live REST/SDK playground for the selected API client. Credentials are prefetched by the `$appId`
// layout loader (shared with the management index).
export const Route = createFileRoute('/_app/account/api/$appId/playground')({
  component: RouteComponent,
  pendingComponent: PanelBlockPending,
})

function RouteComponent() {
  const { appId } = Route.useParams()
  return <Playground appId={appId} />
}
